import { render, staticRenderFns } from "./UserManual.vue?vue&type=template&id=c85b79e0"
import script from "./UserManual.vue?vue&type=script&lang=js"
export * from "./UserManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports